   
function initSlider(element) {
    jQuery(element).galleryView({
	    panel_width: 800,
	    panel_height: 300,
	    frame_width: 52,
	    frame_height: 30,
	    overlay_opacity: 0.8,
	    overlay_color: '#000',
	    overlay_text_color: '#ffffff',
	    caption_text_color: '#ffffff',
	    background_color: 'transparent',
	    border: 'none',
	    nav_theme: 'light',
	    easing: 'easeInOutQuad',
	    pause_on_hover: true,
	    fade_panels: true,
	    transition_speed: 800,
		transition_interval: 10000
    });
    
    jQuery('#loading').remove();
    jQuery('#sliderWrapper').show();
}